import create, { GetState, SetState } from "zustand";
import { Settings } from "../api/types";

type SettingStore = {
  settings: Settings | undefined;
  setSettings: (settings: Settings) => void;
};

const useSettingsStore = create<SettingStore>(
  (set: SetState<SettingStore>, get: GetState<SettingStore>) => ({
    settings: undefined,
    setSettings: (settings: Settings) => set(state => ({ settings })),
  }),
);

export default useSettingsStore;
